"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmptyAnimationImage = exports.StyledEmptyAnimation = exports.StyledAnimationItemLabel = exports.StyledAnimationItem = exports.StyledAnimationGroup = exports.StyledAnimationName = exports.StyledAnimationSummary = exports.StyledAnimationSummaryWrapper = exports.StyledElementList = exports.StyledEffectsImage = exports.StyledEffectsItem = exports.StyledEffectStyle = exports.cssOutlineEffect = exports.StyledEffectsContent = exports.StyledEffectsWrapper = exports.StyledRevertButtonWrapper = exports.StyledElementTab = exports.StyledConfigurationGroup = exports.StyledConfigurationLine = exports.StyledConfigurationAlert = exports.StyledEffectPickerWrapper = exports.StyledConfigurationContent = exports.StyledDivider = exports.StyledConfigurationCaptionWrapper = exports.StyledConfigurationCaption = exports.StyledConfigurationWrapper = exports.StyledTitle = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;
  width: ${ui_common_components_1.utils.rem(300)};
  padding: 0 ${`${ui_common_components_1.utils.rem(6)}`};
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledConfigurationWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledConfigurationCaption = styled_components_1.default.div `
  display: flex;
  flex-flow: column-reverse;
`;
exports.StyledConfigurationCaptionWrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)} 0`};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)}`};
  width: 100%;
`;
exports.StyledDivider = styled_components_1.default.hr `
  ${({ theme }) => (0, styled_components_1.css) `
    height: ${ui_common_components_1.utils.rem(theme.Border.Size.Small)};
    background-color: ${theme.Color.Neutrals.Dark};
  `}

  opacity: 0.06;
  width: 100%;
  border: none;
`;
exports.StyledConfigurationContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledEffectPickerWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  width: 100%;
  flex-direction: column-reverse;
`;
exports.StyledConfigurationAlert = styled_components_1.default.div `
  align-items: stretch;
  justify-content: stretch;
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};

  ${({ theme, isOpened }) => isOpened
    ? (0, styled_components_1.css) `
          display: flex;
          height: auto;
          overflow: visible;
          padding: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)} 0;
          opacity: 1;
        `
    : (0, styled_components_1.css) `
          display: none;
          overflow: hidden;
          height: 0;
          opacity: 0;
          padding: 0;
        `}
`;
exports.StyledConfigurationLine = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${ui_common_components_1.utils.rem(28)};
`;
exports.StyledConfigurationGroup = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledElementTab = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
`;
exports.StyledRevertButtonWrapper = styled_components_1.default.div `
  display: flex;
  margin-bottom: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
`;
exports.StyledEffectsWrapper = styled_components_1.default.div `
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`} 0 0 0;
`;
exports.StyledEffectsContent = styled_components_1.default.div `
  ${({ variant }) => variant === 'headless'
    ? (0, styled_components_1.css) `
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-auto-rows: 1fr;
        `
    : (0, styled_components_1.css) `
          display: flex;
          flex-flow: row wrap;
        `}

  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Grid.Spacing)}`};
`;
exports.cssOutlineEffect = (0, styled_components_1.css) `
  box-shadow: inset 0 0 0
    ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Border.Size.Small)} ${theme.Color.Neutrals.Border}`};
`;
exports.StyledEffectStyle = (0, styled_components_1.css) `
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  ${exports.cssOutlineEffect}
  align-items: center;
  justify-content: center;
  text-align: center;
  ${ui_common_components_1.utils.getFontStyle('Body')};
`;
exports.StyledEffectsItem = styled_components_1.default.div `
  display: inline-flex;
  flex-flow: column;
  box-sizing: border-box;
  width: ${({ full, theme }) => full ? '100%' : `calc(50% - ${theme.Grid.Spacing / 2}px)`};
  height: ${({ full }) => ui_common_components_1.utils.rem(full ? 50 : 80)};
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  ${exports.cssOutlineEffect}
  ${({ theme, active }) => active
    ? `border: solid; border-width: 1.5px; border-color: ${theme.Color.Brand.Primary}`
    : ''};
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  ${ui_common_components_1.utils.getFontStyle('Body')};
  cursor: pointer;
  user-select: none;
  transition: border-color ${({ theme }) => theme.Transition.Timing.Out};
  overflow: hidden;
`;
exports.StyledEffectsImage = styled_components_1.default.div `
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Large)};

  & > div {
    width: 100%;
    height: 100%;
  }
`;
exports.StyledElementList = styled_components_1.default.div `
  display: flex;
  flex-flow: row wrap;
  flex: 1;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
`;
exports.StyledAnimationSummaryWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};
  padding: ${ui_common_components_1.utils.rem(0.5)}; // padding to compensate border width on hover
  ${exports.cssOutlineEffect}
  transition: box-shadow ${({ theme }) => theme.Transition.Timing.Out};

  &:hover {
    transition: box-shadow ${({ theme }) => theme.Transition.Timing.In};
    box-shadow: inset 0 0 0
      ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary}`};
  }
`;
exports.StyledAnimationSummary = styled_components_1.default.div `
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  padding: ${({ group, theme }) => group
    ? `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} ${ui_common_components_1.utils.rem(theme.Spacing.Size.Small - 2)}`
    : `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)} ${ui_common_components_1.utils.rem(theme.Spacing.Size.Small - 2)}`};
  cursor: pointer;
  user-select: none;
  ${ui_common_components_1.utils.getFontStyle('SmallHeavy')};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};
  transition: all ${({ theme }) => theme.Transition.Timing.Out};
`;
exports.StyledAnimationName = (0, styled_components_1.default)(ui_common_components_1.Text) `
  margin-left: auto;
  max-width: ${ui_common_components_1.utils.rem(100)};
`;
exports.StyledAnimationGroup = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  width: 100%;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  ${exports.cssOutlineEffect}
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 0;
`;
exports.StyledAnimationItem = styled_components_1.default.div `
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  flex-flow: row;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  cursor: pointer;
  user-select: none;
  ${ui_common_components_1.utils.getFontStyle('Body')};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};

  i:last-child {
    margin-left: auto;
  }
`;
exports.StyledAnimationItemLabel = styled_components_1.default.div `
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)} ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};
  background: ${({ theme }) => theme.Color.System.Lightest};
`;
exports.StyledEmptyAnimation = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Components.Empty.Margin.Size.Medium)} 0`};
  width: 100%;
  text-align: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
`;
exports.StyledEmptyAnimationImage = styled_components_1.default.div `
  i,
  svg {
    width: ${ui_common_components_1.utils.rem(200)};
    height: ${ui_common_components_1.utils.rem(200)};
  }
`;
//# sourceMappingURL=Animation.style.js.map